module.exports = __webpack_public_path__ + "img/filter-light.43f30fb4.svg";